// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3NeuV","productName":"Table_productName__3cqXX"};